<template>
    <div>
        <TransitionFadeShort v-if="load">
            <MoleculeSkeletonCard />
        </TransitionFadeShort>

        <div v-else>
            <MoleculeEventList :events="events"/>
        </div>
    </div>
</template>

<script>
import TransitionFade from "../../../transitions/TransitionFade.vue";
import MoleculeEventList from "../molecules/MoleculeEventList.vue";
import MoleculeSkeletonCard from "../molecules/MoleculeSkeletonCard.vue";
import TransitionFadeShort from "../../../transitions/TransitionFadeShort.vue";

export default {
    name: "OrganismTabEvents",
    components: {TransitionFadeShort, MoleculeSkeletonCard, MoleculeEventList, TransitionFade },
    props: {
        events: null,
        load: false
    }
};
</script>
